import { Component } from 'react'

class ScrollHandler extends Component {
    constructor(props) {
        super(props)

        this.state = {
            scrollDirDown: false,
            scrollPosition: window.pageYOffset,
        }

        this.handleScroll = this.handleScroll.bind(this)
        window.addEventListener('scroll', this.handleScroll)
    }

    handleScroll() {
        var scrollPos = window.pageYOffset
        var scrollDirDown = scrollPos > this.state.scrollPosition

        if (scrollDirDown !== this.state.scrollDirDown) {
            this.props.onScrollDirChange(scrollDirDown)
        }

        this.setState({
            scrollDirDown: scrollDirDown,
            scrollPosition: scrollPos,
        })
    }

    render() {
        return null
    }
}

export default ScrollHandler
